module.exports = __webpack_public_path__ + "static/media/logo_simple.099be092.svg";